export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-result/index.js